import { fromJS } from 'immutable';
import {
  FETCH_CONTACT_US_SUBJECTS,
  FETCH_CONTACT_US_SUBJECTS_SUCCESS,
  FETCH_CONTACT_US_SUBJECTS_FAILURE,
} from 'containers/ContactUs/constants';

const initialState = fromJS({
  subjects: {
    data: [],
    isFetching: false,
    error: null,
  },
});

export default function contactUsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CONTACT_US_SUBJECTS:
      return state
        .setIn(['subjects', 'isFetching'], true)
        .setIn(['subjects', 'error'], null);

    case FETCH_CONTACT_US_SUBJECTS_SUCCESS:
      return state
        .setIn(['subjects', 'isFetching'], false)
        .setIn(['subjects', 'data'], fromJS(action.payload));

    case FETCH_CONTACT_US_SUBJECTS_FAILURE:
      return state
        .setIn(['subjects', 'isFetching'], false)
        .setIn(['subjects', 'error'], action.payload);

    default:
      return state;
  }
}
